/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contains-email[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;font-size:.9em}.remember-tooltip[_ngcontent-%COMP%]{max-width:400px}"];
export { styles as styles };
